import { hideModal, showModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import AlertIconFilled from "_+_Portal/assets/images/generico/AlertIconFilled";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { PortalContext } from "_+_Portal/context/Provider";
import CardAusente from "_+_Portal/_-_Autocheckin/components/genericos/CardAusente/CardAusente";
import CardCheck from "_+_Portal/_-_Autocheckin/components/genericos/CardCheck/CardCheck";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import ModalAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoT/ModalAutoT";
import ModalErrorAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalErrorAutoT/ModalErrorAutoT";
import { filaVirtualReset } from "_+_Portal/_-_Autocheckin/context/action/filaVirtual";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { wsGetTurnosPacienteDelDia } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BodyContainerP5,
  ButtonP5,
  ContainerButton,
  ContainerP5,
  ContainerSinTurno,
} from "./localStyle";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { DistanciaCentro, OrderTurnos } from "../PagesFun";
import { showToaster } from "global/context/action/toaster/toaster";
import ModalCentro from "_+_Portal/_-_Autocheckin/components/genericos/ModalCentro/ModalCentro";

const TurnosDelDia = () => {
  // -------------------------  useContex  ----------------------------
  const {
    turnosAutoCheckInState,
    turnosSeleccionadosDispatch,
    pasoDispatch,
    turnosAutoCheckInDispatch,
    filaVirtualDispatch,
    puntoControlDispatch,
    textosAutoCheckinState,
    ubicacionState,
  } = useContext(AutocheckContext);
  const { selectDropDownState } = useContext(PortalContext);
  const { modalDispatch, toasterDispatch } = useContext(GlobalContext);
  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  const coordenadas = ubicacionState?.ubicacion?.data;
  let config = localStorage.getItem("config");
  let parsedConfig = {};
  try { parsedConfig = JSON.parse(config) || {}; } catch (e) { parsedConfig = {}; }

  // ========================= MOCK DATA PARA TESTING =========================
  const MOCK_ENABLED = false; // DESACTIVADO - usar datos reales

  const MOCK_TURNOS_PENDIENTES = [
    {
      idturno: 2001,
      especialidad: "DERMATOLOGÍA",
      hora: "14:00",
      centro: "DIM Centro",
      medico: "Dr. Martínez Pedro",
      presente: false,
      checkin: true, // Permite hacer checkin
      ausente: false,
      flgSoloConsulta: true,
      consultorio: "",
      idProtocolo: 0,
      selected: false,
      type: "normal",
    },
    {
      idturno: 2002,
      especialidad: "OFTALMOLOGÍA",
      hora: "16:30",
      centro: "DIM Centro",
      medico: "Dra. Fernández Ana",
      presente: false,
      checkin: true,
      ausente: false,
      flgSoloConsulta: true,
      consultorio: "",
      idProtocolo: 0,
      selected: false,
      type: "normal",
    },
    {
      idturno: 2003,
      especialidad: "NEUROLOGÍA",
      hora: "10:00",
      centro: "DIM San Martín",
      medico: "Dr. Pérez Roberto",
      presente: false,
      checkin: false, // Ya pasó la hora - AUSENTE
      ausente: true,
      flgSoloConsulta: true,
      consultorio: "",
      idProtocolo: 0,
      selected: false,
      type: "ausente", // Esto hace que se muestre como CardAusente
    },
  ];
  // ========================= FIN MOCK DATA =========================

  let initialData = MOCK_ENABLED
    ? MOCK_TURNOS_PENDIENTES
    : turnosAutoCheckInState?.turnosAutoCheckIn?.data;
  if (initialData !== false && !MOCK_ENABLED && Array.isArray(initialData)) {
    initialData = initialData.filter((e) => !e.presente);
  }
  const history = useHistory();
  const idPacFamiliar = selectDropDownState?.selectDropDown?.selectGlobal
    ?.pacienteElegido?.paciente?.codigo
    ? selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido?.paciente
        ?.codigo
    : false;

  let opcAutoCheckInPracticas = parsedConfig.opcAutoCheckInPracticas;
  let filtroHorario =
    textosAutoCheckinState.textosAutoCheckin?.data?.filtroHorario?.orden;
  let minutosToleranciaRecepcion =
    parsedConfig?.minutosToleranciaRecepcion;
  let minRecepcionVariosTurnos = parsedConfig?.minRecepcionVariosTurnos;
  let descHorario =
    textosAutoCheckinState.textosAutoCheckin?.data?.filtroHorario?.descripcion;
  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------
  const [turnos, setTurnos] = useState(initialData);
  const [turnosSinAusente, setTurnosSinAusente] = useState([]);
  const [loading, setLoading] = useState(true);

  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const handleClickButton = () => {
    if (!turnos || turnos.length === 0) return;
    let turnosRechazados = turnos.filter((e) => !e.checkin);
    let turnosSeleccionados = turnos.filter(
      (e) => e.selected && !(e.type === "ausente") && e.checkin,
    );
    let turnosSinAusente = turnos.filter(
      (e) => !(e.type === "ausente") && DistanciaCentro(coordenadas, e),
    );

    if (turnosRechazados.length > 0) {
      setTurnosSeleccionado(turnosRechazados)(turnosSeleccionadosDispatch);
      setLoading(true);
      const idTipoPuntoControl = 6;
      setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
      setPaso("PuntoControl")(pasoDispatch);
    } else if (turnosSeleccionados.length > 0) {
      setTurnosSeleccionado(turnosSeleccionados)(turnosSeleccionadosDispatch);
      if (turnosSeleccionados.length < turnosSinAusente.length) {
        showModalDiaHoy(
          <ModalAutoT
            dissmiss={dissmiss}
            desc={
              "Te falta seleccionar algún turno. ¿Querés avanzar con la recepción de tus otros turnos?"
            }
            title={"Recepción"}
            textBtnOne={"SI"}
            textBtnTwo={"NO"}
            handleChange={{
              btnOne: () => {
                dissmiss();
                // setPaso("UbicacionActual")(pasoDispatch);
                setPaso("NumeroAfiliado")(pasoDispatch);
              },
              btnTwo: () => {
                dissmiss();
              },
            }}
          />,
          "Información",
        );
      } else {
        let turnosCentro = turnosSeleccionados.filter((e) =>
          DistanciaCentro(coordenadas, e),
        );
        if (turnosCentro.length === 0) {
          setPaso("OtroCentro")(pasoDispatch);
        } else {
          setPaso("NumeroAfiliado")(pasoDispatch);
        }
        // setPaso("UbicacionActual")(pasoDispatch);
      }
    } else {
      showModalDiaHoy(
        <ModalErrorAutoT
          dissmiss={dissmiss}
          errorMsg={"Debe seleccionar al menos un turno."}
        />,
      );
    }
  };
  const volver = () => {
    setPaso("Home")(pasoDispatch);
  };
  const dissmiss = () => {
    hideModal()(modalDispatch);
  };
  const showModalDiaHoy = (content, title) => {
    showModal(
      content,
      title,
      dissmiss,
      false,
      {},
      "centro",
      true,
    )(modalDispatch);
  };

  const handleSeleccionar = (item, isSelected) => {
    if (!DistanciaCentro(coordenadas, item)) {
      showModal(
        <ModalCentro item={item} />,
        "Aviso",
        dissmiss,
        false,
        {},
        "centro",
        true,
      )(modalDispatch);
    } else {
      const newTurnos = turnos.map((element, key) => {
        if (element.idturno === item.idturno) {
          if (element?.type === "fueraRangoHorario") {
            showToaster(
              {
                texto: descHorario,
                tipo: "danger",
              },
              "centroArriba",
            )(toasterDispatch);
          } else {
            element.selected = isSelected;
          }
        }
        return element;
      });
      setTurnos(newTurnos);
    }
  };
  // -------------------------  funciones  ----------------------------

  // -------------------------  useEffect  ----------------------------
  useEffect(() => {
    // Si está en modo MOCK, usar los datos mock directamente
    if (MOCK_ENABLED) {
      console.log(
        "🧪 MOCK TurnosDelDia: Usando datos mock",
        MOCK_TURNOS_PENDIENTES,
      );
      const turnosSinAusenteMock = MOCK_TURNOS_PENDIENTES.filter(
        (turno) => turno.ausente === false,
      );
      setTurnosSinAusente(turnosSinAusenteMock);
      setTurnos(MOCK_TURNOS_PENDIENTES);
      setLoading(false);
      filaVirtualReset()(filaVirtualDispatch);
      return;
    }

    let nextStep = (isCorrect, data) => {
      if (isCorrect && data) {
        data = data.filter((e) => !e.presente);

        const turnosOrdenados = OrderTurnos(
          data,
          filtroHorario,
          minutosToleranciaRecepcion,
          minRecepcionVariosTurnos,
          false,
          coordenadas,
        );

        const kinesioVerificaRecepcion = turnosOrdenados.filter(
          (turno) => turno.type === "kinesioVerificacion",
        );
        const osValidacionInterna = turnosOrdenados.filter(
          (turno) => turno.type === "osValidacionInterna",
        );
        const noPermiteCheckIn = turnosOrdenados.filter(
          (turno) => turno.type === "noPermiteCheckIn",
        );
        const practicas = turnosOrdenados.filter(
          (turno) => turno.type === "practica",
        );

        const turnosSinAusente = turnosOrdenados.filter(
          (turno) => turno.ausente === false,
        );
        setTurnosSinAusente(turnosSinAusente);

        if (kinesioVerificaRecepcion.length > 0) {
          setTurnosSeleccionado(kinesioVerificaRecepcion)(
            turnosSeleccionadosDispatch,
          );
          const idTipoPuntoControl = 12;
          setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
          setPaso("PuntoControl")(pasoDispatch);
        } else if (osValidacionInterna.length > 0) {
          setTurnosSeleccionado(osValidacionInterna)(
            turnosSeleccionadosDispatch,
          );
          const idTipoPuntoControl = 13;
          setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
          setPaso("PuntoControl")(pasoDispatch);
        } else if (noPermiteCheckIn.length > 0) {
          setTurnosSeleccionado(noPermiteCheckIn)(turnosSeleccionadosDispatch);
          const idTipoPuntoControl = 1;
          setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
          setPaso("PuntoControl")(pasoDispatch);
        } else if (!opcAutoCheckInPracticas && practicas.length > 0) {
          setTurnosSeleccionado(practicas)(turnosSeleccionadosDispatch);
          const idTipoPuntoControl = 2;
          setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
          setPaso("PuntoControl")(pasoDispatch);
        } else {
          setLoading(false);
          setTurnos(turnosOrdenados);
        }
        setTurnos(turnosOrdenados);
      } else {
        setLoading(false);
      }
    };

    if (loading) {
      wsGetTurnosPacienteDelDia(
        idPacFamiliar,
        nextStep,
      )(turnosAutoCheckInDispatch);
    }
    filaVirtualReset()(filaVirtualDispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // -------------------------  useEffect  ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />

      <LayoutPasos
        volverTo={"/autocheckin"}
        handleClick={volver}
        title={"Tengo Turno"}
        subtitle={
          "Éstos son tus turnos para hoy. Tocá el que querés y luego presioná el botón 'Recepcionarme'."
        }
        minSizeTxt={true}
      >
        <ContainerP5
          initial={{ opacity: 0, y: +100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.4 }}
        >
          <BodyContainerP5>
            {loading
              ? ""
              : turnos
                ? turnos.map((element, key) => {
                    if (element?.type === "ausente") {
                      return (
                        <CardAusente
                          title={element.especialidad}
                          horario={element.hora}
                          sede={element.centro}
                          medico={element.medico}
                          key={key}
                          setTurnos={setTurnos}
                          turnos={turnos}
                          id={element.idturno}
                          actived={element.selected}
                          flgSoloConsulta={element.flgSoloConsulta}
                        />
                      );
                    } else {
                      return (
                        <CardCheck
                          title={element.especialidad}
                          horario={element.hora}
                          sede={element.centro}
                          medico={element.medico}
                          key={key}
                          setTurnos={setTurnos}
                          turnos={turnos}
                          id={element.idturno}
                          actived={element.selected}
                          flgSoloConsulta={element.flgSoloConsulta}
                          setSelected={(isSelected) =>
                            handleSeleccionar(element, isSelected)
                          }
                        />
                      );
                    }
                  })
                : ""}

            {(!turnos || turnos.length === 0) && !loading ? (
              <ContainerSinTurno>
                <AlertIconFilled
                  height={"70"}
                  width={"70"}
                  color={"var(--color-latex10)"}
                />
                <span className="title">
                  No se encotraron turnos para el día de hoy
                </span>
                <span className="subtitle">
                  Puede acceder a sus próximos turnos con el botón que se
                  encuentra debajo
                </span>
              </ContainerSinTurno>
            ) : (
              ""
            )}
            {loading ? (
              ""
            ) : (
              <ContainerButton>
                <>
                  {turnosSinAusente?.length > 0 ? (
                    <ButtonP5 onClick={handleClickButton}>
                      Recepcionarme
                    </ButtonP5>
                  ) : (
                    ""
                  )}
                  <ButtonP5
                    latex10={1}
                    onClick={() => {
                      history.push("/proximosTurnos");
                    }}
                  >
                    Próximos turnos
                  </ButtonP5>
                </>
              </ContainerButton>
            )}
          </BodyContainerP5>
        </ContainerP5>
      </LayoutPasos>
    </>
  );
};

export default TurnosDelDia;
